import { InputNumberPlus } from "./InputNumberPlus";

export const InputCurrency = (props) => {
  return (
    <InputNumberPlus thousandsSeparator {...props} />
  );
};